import { APP_INITIALIZING, APP_INITIALIZED, APP_SET_THEME } from './AppActions';
import themes from '../../shared/style/themes/themes';

const initialState = { initialized: false, siteTheme: themes.default };

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_INITIALIZING:
      return { ...state, initialized: false };
    case APP_INITIALIZED:
      return { ...state, initialized: true };
    case APP_SET_THEME:
      return { ...state, siteTheme: action.theme };
    default:
      return state;
  }
};
